import { gql } from "@apollo/client";

const DELETED_TOURNAMENTS = gql`
  query deletedTournaments(
    $page: Int
    $limit: Int
    $filter: ListTournamentInput
    $platform: Int
    $organization: Int
  ) {
    deletedTournaments(
      page: $page
      limit: $limit
      filter: $filter
      platform: $platform
      organization: $organization
    )
  }
`;

export default DELETED_TOURNAMENTS;
